import { __assign } from '../../../../../_virtual/_tslib.js';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { classNames } from '../../../../../utils/common/styling.js';
import { styled, IconButton, AccordionDetails } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import RightIcon from '@mui/icons-material/ChevronRightRounded';
import EditIcon from '@mui/icons-material/CreateOutlined';
import DragIcon from '@mui/icons-material/DragIndicatorOutlined';
import SectionCTA from '../../SectionCTA/SectionCTA.js';
import SidebarCta from '../../SidebarCta/SidebarCta.js';
import { styles } from './Collection.styles.js';

var Accordion = styled(function (props) { return (React.createElement(MuiAccordion, __assign({ disableGutters: true, elevation: 0, square: true }, props))); })(function () { return ({
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&:before": {
        display: "none",
    },
}); });
var AccordionSummary = styled(function (props) { return (React.createElement(MuiAccordionSummary, __assign({}, props))); })(function () { return ({
    padding: "0px 16px 0px 18px",
    minHeight: 0,
    "& .MuiAccordionSummary-content": {
        margin: 0,
        cursor: "default",
    },
}); });
var Collection = function (_a) {
    var expanded = _a.expanded, showActions = _a.showActions, showDiviver = _a.showDivider, index = _a.index, collection = _a.collection, selectedChannelId = _a.selectedChannelId, onClick = _a.onClick, onClickChannel = _a.onClickChannel, onEdit = _a.onEdit, onAddChannel = _a.onAddChannel;
    var label = collection.label, channels = collection.channels, id = collection.id;
    return (React.createElement(Draggable, { draggableId: "draggable-".concat(id), index: index }, function (provided, snapshot) { return (React.createElement("div", __assign({ className: classNames(styles.root), ref: provided.innerRef }, provided.draggableProps),
        React.createElement(Accordion, { classes: {
                root: classNames(styles.accordionRoot, snapshot.isDragging && styles.draggable),
            }, expanded: expanded },
            React.createElement(AccordionSummary, null,
                React.createElement("div", { className: classNames(styles.header, !showDiviver && styles.noMargin) },
                    React.createElement("div", { className: styles.label, onClick: function (event) {
                            return onClick === null || onClick === void 0 ? void 0 : onClick({ collection: collection, event: event, index: index });
                        } },
                        label,
                        React.createElement(IconButton, { className: classNames(styles.expandCta, expanded && styles.expanded) },
                            React.createElement(RightIcon, null))),
                    showActions && (React.createElement("div", { className: styles.actions },
                        React.createElement(IconButton, { onClick: function (event) { return onEdit === null || onEdit === void 0 ? void 0 : onEdit({ collection: collection, event: event }); } },
                            React.createElement(EditIcon, null)),
                        React.createElement("div", __assign({}, provided.dragHandleProps),
                            React.createElement(DragIcon, { className: styles.dragCta })))))),
            React.createElement(AccordionDetails, { className: styles.details }, channels === null || channels === void 0 ? void 0 :
                channels.map(function (channel, index) {
                    var label = channel.label, icon = channel.icon, id = channel.id;
                    return (React.createElement(SectionCTA, { key: id, label: label, icon: icon, onClick: function (event) {
                            return onClickChannel === null || onClickChannel === void 0 ? void 0 : onClickChannel({ channel: channel, index: index, event: event });
                        }, active: selectedChannelId === id }));
                }),
                showActions && (React.createElement(SidebarCta, { label: "Add channel", ctaVariant: "secondary", className: styles.addCta, onClick: function (event) { return onAddChannel === null || onAddChannel === void 0 ? void 0 : onAddChannel({ collection: collection, event: event }); } })))),
        showDiviver && !snapshot.isDragging && (React.createElement("hr", { className: styles.divider })))); }));
};

export { Collection as default };
//# sourceMappingURL=Collection.js.map
